import React, { useState } from 'react';
import { bool, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    setAgent
} from '../../actions/erpAgentActions';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './ErpAgentsTableRowMenu.module.css';

/*const ManageUrl = template.parse('/iothub/erpagents/manage{?company,erpAgent}');*/

const ErpAgentsTableRowMenu = ({
    agent,
    companyInfo,
    hidden,
    history,
    location,
    onDeleteModal,
    onRenameAgentModal,
    onRotateCredentialsModal,
    setAgent
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    //function handleManage() {
    //    const values = new URLSearchParams(location.search);
    //    setAgent(agent);
    //    history.push(ManageUrl.expand({
    //        erpAgent: agent.id,
    //        company:  values.get('company')
    //    }));
    //}

    function handleRotateCredentials() {
        setAgent(agent);
        onRotateCredentialsModal(agent);
        handleClose();
    }

    function handleToggleDeleteModal() {
        setAgent(agent);
        onDeleteModal(agent);
        handleClose();
    }

    function handleToggleRenameAgentModal() {
        onRenameAgentModal(agent);
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    /*
                    <MenuItem onClick={handleManage}>
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/SettingsFlat.svg"
                        />
                        Manage Agent
                    </MenuItem>
                    */
                }
                <MenuItem onClick={handleRotateCredentials}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/secureIconFlat.svg"
                    />
                    Rotate Integration Credentials
                </MenuItem>
                <MenuItem onClick={handleToggleRenameAgentModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/erpAgentIconColor.svg"
                    />
                    Rename Agent
                </MenuItem>
                <MenuItem onClick={handleToggleDeleteModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/actionBarItem-delete.svg"
                    />
                    Delete Agent
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

ErpAgentsTableRowMenu.defaultProps = {
    hidden:               false,
    onAssignAgentModal:   () => {},
    onDeleteModal:        () => {},
    onRenameAgentModal:   () => {},
    onUnAssignAgentModal: () => {},
    setAgent:             () => {}
};

ErpAgentsTableRowMenu.propTypes = {
    agent:                object,
    companyInfo:          object,
    hidden:               bool,
    history:              object,
    location:             object,
    onAssignAgentModal:   func,
    onDeleteModal:        func,
    onRenameAgentModal:   func,
    onUnAssignAgentModal: func,
    setAgent:             func
};

const mapDispatchToProps = {
    setAgent
};

export default withRouter(
    connect(null, mapDispatchToProps)(ErpAgentsTableRowMenu)
);
